export { HeaderLeft, HeaderRow, ReportCardContainer } from '../components';

import { Box, styled, Text } from '@ltvco/refresh-lib/theme';

export const PersonName = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  fontSize: 20,
  color: theme.palette.text.primary,
  display: 'block',
  marginBottom: 16,
}));

export const AncestryLinkedSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});
